import QueriesList from './QueriesList';

export default QueriesList;
